var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconCel = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31.9628 47.9988C35.1848 47.9988 37.7955 45.3415 37.7955 42.0646V5.93419C37.7955 2.65732 35.1848 0 31.9628 0H16.0356C12.8137 0 10.2041 2.65732 10.2041 5.93419V42.0658C10.2041 45.3427 12.8137 48 16.0356 48L31.9628 47.9988ZM24.0016 44.8616C22.4318 44.8616 21.1605 43.5914 21.1605 42.024C21.1605 40.4566 22.4318 39.1876 24.0016 39.1876C25.5678 39.1876 26.838 40.4566 26.838 42.024C26.838 43.5914 25.5678 44.8616 24.0016 44.8616ZM13.7997 34.4221V8.98068C13.7997 7.66157 14.8681 6.59315 16.1872 6.59315H31.8124C33.1315 6.59315 34.1999 7.66157 34.1999 8.97948C34.1999 14.6296 34.1999 28.7697 34.1999 34.421C34.1999 35.7401 33.1315 36.8085 31.8124 36.8085H16.1872C14.8681 36.8097 13.7997 35.7413 13.7997 34.4221Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 8.70508,
  y: 15.3682,
  width: 33.0149,
  height: 5.69819,
  transform: "rotate(15 8.70508 15.3682)",
  fill: "#F5F5F5",
  stroke: "none"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_cel.424431d3.svg";
export { ForwardRef as ReactComponent };